import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import ChartCard from "./ChartCard";
import { CHART_COLORS, getChartTheme } from "../utils/chartTheme";

export default function HoursOverTimeChart({ data = [], isDarkMode = false }) {
  const theme = getChartTheme(isDarkMode);
  return (
    <ChartCard title="Ore në kohë" empty={!data.length} accent={CHART_COLORS.teal}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 8, right: 12, left: 0, bottom: 4 }}
          barCategoryGap="28%"
        >
          <CartesianGrid {...theme.cartesianProps} />
          <XAxis
            dataKey="name"
            tick={theme.tickProps}
            axisLine={theme.axisLine}
            tickLine={theme.tickLine}
          />
          <YAxis
            tick={theme.tickProps}
            axisLine={theme.axisLine}
            tickLine={theme.tickLine}
            width={44}
          />
          <Tooltip
            contentStyle={theme.tooltipContentStyle}
            labelStyle={theme.tooltipLabelStyle}
            itemStyle={theme.tooltipItemStyle}
            cursor={{ fill: theme.cursorFill }}
          />
          <Legend {...theme.legendProps} />
          <Bar
            dataKey="before19"
            name="Para 19:00"
            stackId="h"
            fill={CHART_COLORS.teal}
            radius={[0, 0, 0, 0]}
          />
          <Bar
            dataKey="between19and22"
            name="19:00 - 22:00"
            stackId="h"
            fill={CHART_COLORS.yellow}
          />
          <Bar
            dataKey="after22"
            name="Pas 22:00"
            stackId="h"
            fill={CHART_COLORS.red}
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
